import _ from 'lodash';

export const getOffersFormConfig = (state: {}): any => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-my-privileges.offers.form`,
    {},
  );
};

export const getOffersFormData = (state: {}): any => {
  return _.get(state, `hk-emma-web-module-offers/offers`);
};

export const getOffersConfig = (state: {}): any => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-my-privileges.offers`,
    {},
  );
};

export const getOffersFormSubmitApiApi = (state: {}): any => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-my-privileges.offers.form.offersFormSubmitApi`,
    {},
  );
};

export const getOffersSmartHomeConfig = (state: {}): any => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-my-privileges.offers.smartHome`,
    {},
  );
};

export const getOffersCardsByFeatureIdConfig = (
  state: {},
  sectionId: string,
  featureId: string,
): any => {
  const offerSections = _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-my-privileges.offers.offerSections`,
    [],
  );
  const offerSectionsModel = _.find(
    offerSections,
    (item) => item.id === sectionId,
  );
  const offersCards =
    offerSectionsModel && offerSectionsModel.cards
      ? _.find(offerSectionsModel.cards, (item) => item.featureId === featureId)
      : {};
  return offersCards;
};

// HKEMMA-99501: offers API decommission - depreciated in Emma1.5
// export const getOffersFeatureUrl = (state: {}): string => {
//   return _.get(
//     state,
//     `hk-emma-web-core/app.moduleConfig.emma-axa-promotional-offer.emmaOffersUrl`,
//     '',
//   );
// };

export const getOffersFeaturesConfig = (state: {}): string => {
  return _.get(state, `hk-emma-web-core/offers.offersFeaturesConfig`, {});
};

// HKEMMA-99501: offers API decommission - depreciated in Emma1.5
// export const getOffersFeatures = (state: {}): string => {
//   return _.get(
//     state,
//     `hk-emma-web-core/offers.offersFeaturesConfig.offersFeatures`,
//     [],
//   );
// };

export const getIsPromotionChecked = (state: {}): string => {
  return _.get(
    state,
    `hk-emma-web-module-offers/offers.isPromotionChecked`,
    false,
  );
};
